import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'src/app/core/services/alert.service';

@Component({
  selector: 'app-all-push-modal',
  templateUrl: './all-push-modal.component.html',
  styleUrls: ['./all-push-modal.component.scss'],
})
export class AllPushModalComponent implements OnInit {
  constructor(private modalService: NgbModal, private alertService: AlertService) {}

  ngOnInit(): void {}
  // 모달 닫기
  close() {
    this.modalService.dismissAll();
  }

  // 전송 - [확인] 선택 시 전체푸시전송
  send() {
    this.alertService.successConfirm('', '메시지를 전송하시겠습니까?', '확인');
  }
}
